import {get, post} from '@/axios';
// 获取数据字典树结果
 export const getTreeData = p => post('dictionary/getTreeData', p);
//添加数据字典
 export const insertDictionary = p => post('dictionary/insert', p);
//删除数据字典
 export const deleteDictionary = p => post('dictionary/delete', p);
//编辑数据字典
 export const updateDictionary = p => post('dictionary/update', p);
//数据字典一览
 export const getPageList = p => post('dictionary/getPageList', p);
 //资讯类型一览
 export const getInformationType = p => post('dictionary/getInformationType', p);
 //根据Pcode查询数据字典
 export const getOptionItem = p => get('dictionary/getDicChildList', p);





// WEBPACK FOOTER //
// ./src/api/system/Dictionary.js